import '.g{display:flex;}.ssr-plugin'
import '.k{flex-direction:column;}.ssr-plugin'
import '.ac{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.ad{border-radius:1.25rem;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.w{overflow:hidden;}.ssr-plugin'
import '.cu{padding:1rem 1.5rem;}.ssr-plugin'
import '.cv{background:var(--shades-white);}.ssr-plugin'
import '.a7{justify-content:space-between;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.cw{align-self:center;}.ssr-plugin'
import '.bv{padding:1.5rem;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import '.a{display:grid;}.ssr-plugin'
import '.h{justify-content:center;}.ssr-plugin'
import '.a6{width:100%;}.ssr-plugin'
import '.cx{gap:0.75rem;}.ssr-plugin'
import '.bs{padding:1rem;}.ssr-plugin'
import '.by{background-color:var(--shades-blue-50);}.ssr-plugin'
import '.b7{border:none;}.ssr-plugin'
import '.cy{border-radius:1rem;}.ssr-plugin'
import '.bc{cursor:pointer;}.ssr-plugin'
import '.cz{transition:background-color 0.2s ease;}.ssr-plugin'
import '.d0{width:1rem;}.ssr-plugin'
import '.d1{height:1rem;}.ssr-plugin'
import '.b1{color:var(--primary-blue);}.ssr-plugin'
import '.d2{font-size:1.15rem;}.ssr-plugin'
import '.b3{font-weight:400;}.ssr-plugin'
import '.d3{justify-content:flex-end;}.ssr-plugin'
import { styled } from 'inlines'
import { useState } from 'react'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { Title } from '@app/components/core/typography/Title'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import { ModalWrapper } from './ModalWrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLink } from '@fortawesome/pro-regular-svg-icons'
import { faXTwitter, faFacebook, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { SocialMediaButton } from './SocialMediaButton'

export type SocialShareModalProps = {
  isOpen: boolean
  onClose: () => void
  url?: string
  title?: string
  renderContainer?: HTMLElement
}

export const SocialShareModal = ({
  isOpen,
  onClose,
  url: urlProp,
  title: titleProp,
  renderContainer,
}: SocialShareModalProps) => {
  const translations = useTranslations().app.socialShareModal
  const isMobile = useMediaQuery()
  const [copySuccess, setCopySuccess] = useState(false)

  const url =
    urlProp ?? (typeof window !== 'undefined' ? window.location.href : '')
  const title =
    titleProp ?? (typeof document !== 'undefined' ? document.title : '')

  const handleClose = () => {
    setCopySuccess(false)
    onClose()
  }

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setCopySuccess(true)
        setTimeout(() => setCopySuccess(false), 2000)
      })
      .catch((err) => {
        console.error('Failed to copy link:', err)
      })
  }

  const handleEmailShare = () => {
    const subject = encodeURIComponent(`Check out: ${title}`)
    const body = encodeURIComponent(
      `I thought you might be interested in this: ${url}`,
    )
    window.open(`mailto:?subject=${subject}&body=${body}`)
  }

  const handleXShare = () => {
    const text = encodeURIComponent(`Check out: ${title}`)
    window.open(
      `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(url)}`,
    )
  }

  const handleFacebookShare = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    )
  }

  const handleWhatsAppShare = () => {
    const text = encodeURIComponent(`Check out: ${title} - ${url}`)
    window.open(`https://wa.me/?text=${text}`)
  }

  if (!isOpen) {
    return null
  }

  const content = (
    <div className="g k ac ad ae w"
      data-testid="social-share-modal"
      style={{
        maxWidth: isMobile ? '90vw' : '29.5rem',
      }}
    >
      {/* Header */}
      <div className="g cu cv a7 l"
      >
        <Title.H5 style={{ margin: 0 }}>
          {translations.title}
        </Title.H5>
        <CloseButton onClick={handleClose} size="small" />
      </div>

      {/* Content */}
      <div className="g cw k bv cv c"
      >

        {/* Social Media Buttons */}
        <div className="a c" 
          style={{
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',}}
        >
          <SocialMediaButton icon={faEnvelope} label={translations.email} onClick={handleEmailShare} isMobile={isMobile} />
          <SocialMediaButton icon={faXTwitter} label={translations.x} onClick={handleXShare} isMobile={isMobile} />
          <SocialMediaButton icon={faFacebook} label={translations.facebook} onClick={handleFacebookShare} isMobile={isMobile} />
          <SocialMediaButton icon={faWhatsapp} label={translations.whatsapp} onClick={handleWhatsAppShare} isMobile={isMobile} />
        </div>

        {/* Copy Link Button */}
        <styled.button className="g l h a6 cx bs by b7 cy bc cz"
          onClick={handleCopyLink}
          style={{
            '&:hover': {
              backgroundColor: 'var(--shades-blue-100)',
            },
          }}
        >
          <div className="d0 d1 g l h b1"
          >
            <FontAwesomeIcon icon={faLink} />
          </div>
          <span className="d2 b1 b3"
          >
            {copySuccess ? translations.copiedLink : translations.copyLink}
          </span>
        </styled.button>
      </div>

      {/* Footer */}
      <div className="g cu cv d3 l"
      >
        <Button
          label={translations.close}
          onClick={handleClose}
          variant="primary"
          size="medium"
          style={{
            backgroundColor: 'var(--primary-red)',
            borderColor: 'var(--primary-red)',
          }}
        />
      </div>
    </div>
  )

  return (
    <ModalWrapper renderContainer={renderContainer}>{content}</ModalWrapper>
  )
}
